import { render, staticRenderFns } from "./RTDBNotifications.vue?vue&type=template&id=03884c22&"
import script from "./RTDBNotifications.vue?vue&type=script&lang=js&"
export * from "./RTDBNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports